<form [formGroup]="selectionForm" class="selection-form">
  <div class="form-section">
    <div class="form-item two-col">
      <label for="services">
        {{
          "CARRIERDB.NEW_CARRIER_FORM.SERVICES" | translate : locale.language
        }}</label
      >
      <p-multiSelect
        id="services"
        formControlName="services"
        [options]="services"
        placeholder="{{
          'CARRIERDB.PLACEHOLDER.SERVICES' | translate : locale.language
        }}"
      />
    </div>
    <div class="form-item two-col">
      <label for="industries">
        {{
          "CARRIERDB.NEW_CARRIER_FORM.INDUSTRIES" | translate : locale.language
        }}</label
      >
      <p-multiSelect
        id="industries"
        formControlName="industries"
        [options]="industries"
        placeholder="{{
          'CARRIERDB.PLACEHOLDER.INDUSTRIES' | translate : locale.language
        }}"
      />
    </div>
  </div>
  <p-divider>
    <b>
      {{ "CARRIERDB.NEW_CARRIER_FORM.SEGMENTS" | translate : locale.language }}
    </b>
  </p-divider>
  <div class="form-section">
    <div class="form-item two-col">
      <label for="sea">
        {{
          "CARRIERDB.NEW_CARRIER_FORM.SEA" | translate : locale.language
        }}</label
      >
      <p-multiSelect
        id="sea"
        formControlName="segmentsSea"
        [options]="segments.sea"
        placeholder="{{
          'CARRIERDB.PLACEHOLDER.SEGMENTS' | translate : locale.language
        }}"
      />
    </div>
    <div class="form-item two-col">
      <label for="road">
        {{
          "CARRIERDB.NEW_CARRIER_FORM.ROAD" | translate : locale.language
        }}</label
      >
      <p-multiSelect
        id="road"
        formControlName="segmentsRoad"
        [options]="segments.road"
        placeholder="{{
          'CARRIERDB.PLACEHOLDER.SEGMENTS' | translate : locale.language
        }}"
      />
    </div>
    <div class="form-item two-col">
      <label for="air">
        {{
          "CARRIERDB.NEW_CARRIER_FORM.AIR" | translate : locale.language
        }}</label
      >
      <p-multiSelect
        id="air"
        formControlName="segmentsAir"
        [options]="segments.air"
        placeholder="{{
          'CARRIERDB.PLACEHOLDER.SEGMENTS' | translate : locale.language
        }}"
      />
    </div>
    <div class="form-item two-col">
      <label for="rail">
        {{
          "CARRIERDB.NEW_CARRIER_FORM.RAIL" | translate : locale.language
        }}</label
      >
      <p-multiSelect
        id="rail"
        formControlName="segmentsRail"
        [options]="segments.rail"
        placeholder="{{
          'CARRIERDB.PLACEHOLDER.SEGMENTS' | translate : locale.language
        }}"
      />
    </div>
  </div>
  <p-divider>
    <b>
      {{ "CARRIERDB.NEW_CARRIER_FORM.REGIONS" | translate : locale.language }}
    </b>
  </p-divider>
  <div class="form-section">
    <div class="form-item two-col">
      <label for="europe">
        {{ "CARRIERDB.REGION.EUROPE" | translate : locale.language }}</label
      >
      <p-multiSelect
        id="europe"
        formControlName="regionsEurope"
        [options]="regions.europe"
        optionLabel="name"
        placeholder="{{
          'CARRIERDB.PLACEHOLDER.LOCATIONS' | translate : locale.language
        }}"
      />
    </div>
    <div class="form-item two-col">
      <label for="north-america">
        {{
          "CARRIERDB.REGION.NORTH_AMERICA" | translate : locale.language
        }}</label
      >
      <p-multiSelect
        id="north-america"
        formControlName="regionsNorthAmerica"
        [options]="regions.na"
        optionLabel="name"
        placeholder="{{
          'CARRIERDB.PLACEHOLDER.LOCATIONS' | translate : locale.language
        }}"
      />
    </div>
    <div class="form-item two-col">
      <label for="south-america">
        {{ "CARRIERDB.REGION.EUROPE" | translate : locale.language }}</label
      >
      <p-multiSelect
        id="south-america"
        formControlName="regionsSouthAmerica"
        [options]="regions.sa"
        optionLabel="name"
        placeholder="{{
          'CARRIERDB.PLACEHOLDER.LOCATIONS' | translate : locale.language
        }}"
      />
    </div>
    <div class="form-item two-col">
      <label for="africa">
        {{ "CARRIERDB.REGION.AFRICA" | translate : locale.language }}</label
      >
      <p-multiSelect
        id="africa"
        formControlName="regionsAfrica"
        [options]="regions.africa"
        optionLabel="name"
        placeholder="{{
          'CARRIERDB.PLACEHOLDER.LOCATIONS' | translate : locale.language
        }}"
      />
    </div>
    <div class="form-item two-col">
      <label for="asia">
        {{ "CARRIERDB.REGION.ASIA" | translate : locale.language }}</label
      >
      <p-multiSelect
        id="asia"
        formControlName="regionsAsia"
        [options]="regions.asia"
        optionLabel="name"
        placeholder="{{
          'CARRIERDB.PLACEHOLDER.LOCATIONS' | translate : locale.language
        }}"
      />
    </div>
    <div class="form-item two-col">
      <label for="australia-pacific">
        {{
          "CARRIERDB.REGION.AUSTRALIA_PACIFIC" | translate : locale.language
        }}</label
      >
      <p-multiSelect
        id="australia-pacific"
        formControlName="regionsAustraliaPacific"
        [options]="regions.australiaPacific"
        optionLabel="name"
        placeholder="{{
          'CARRIERDB.PLACEHOLDER.LOCATIONS' | translate : locale.language
        }}"
      />
    </div>
  </div>
</form>
